import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionCreationRejectionReason from "./exemptionCreationRejectionReason";
import type ExemptionCreationWarningReason from "./exemptionCreationWarningReason";
import VehicleResponse from "./vehicleResponse";
import VehicleRegisterVehicleClassifiedFuelType from "./vehicleRegisterVehicleClassifiedFuelType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionPreviewResponse {
  /**
   * If true - exemption can be created.
   */
  @observable
  canBeCreated!: boolean;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  /**
   * Exemption reason ID.
   */
  @observable
  exemptionReasonId!: string;

  /**
   * ClassifiedFuelType.
   */
  @observable
  vehicleClassifiedFuelType?: VehicleRegisterVehicleClassifiedFuelType;

  /**
   * Exemption is valid since this date and time.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Exemption is valid until this date and time.
   */
  @observable
  @Type(() => Date)
  validUntil?: Date;

  @observable
  rejectionReason?: ExemptionCreationRejectionReason;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons!: ExemptionCreationWarningReason[];
}
